import filterAPI from "../api/filterAPI";
import { ActionTypesScreen2 } from "app/constants";


export function fetchAverageData(region_name) {
  return (dispatch) => {
    filterAPI
      .getAverageDetailsScreen2({"region_name": region_name })
      .then((res) => {
        let averageData = res.data.data;
        dispatch(handleAverageData(averageData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleAverageData(data) {
  return {
    type: ActionTypesScreen2.GET_AVERAGE_DATA,
    payload: data,
  };
}

export function fetchCountData(region_name, dropdown_value) {
  return (dispatch) => {
    filterAPI
      .getCountDetailsScreen2({"region_name": region_name, "dropdown_value": dropdown_value })
      .then((res) => {
        let countData = res.data.data;
        dispatch(handleCountData(countData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleCountData(data) {
  return {
    type: ActionTypesScreen2.GET_COUNT_DATA,
    payload: data,
  };
}

export function fetchPercentData(region_name, dropdown_value) {
  return (dispatch) => {
    filterAPI
      .getPercentDetailsScreen2({"region_name": region_name, "dropdown_value": dropdown_value })
      .then((res) => {
        let percentData = res.data.data;
        dispatch(handlePercentData(percentData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handlePercentData(data) {
  return {
    type: ActionTypesScreen2.GET_PERCENT_DATA,
    payload: data,
  };
}

export function fetchGrowthData(region_name) {
  return (dispatch) => {
    filterAPI
      .getGrowthDetailsScreen2({"region_name": region_name })
      .then((res) => {
        let growthData = res.data.data;
        dispatch(handleGrowthData(growthData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleGrowthData(data) {
  return {
    type: ActionTypesScreen2.GET_GROWTH_DATA,
    payload: data,
  };
}

export function updateJobTypeS2(quality_of_jobs) {
  return (dispatch) => {
    dispatch(setJobTypeS2(quality_of_jobs));
  };
}

function setJobTypeS2(data) {
  return {
    type: ActionTypesScreen2.SET_SELECTED_JOB_TYPE_S2,
    payload: data,
  };
}
